<template>
<w-sliding-popup ref="slidingPopup" title="대상 선택" width="700px" :defaultContent="false" class="log-select-popup" @close="closed">
  <div slot="content" class="content-wrapper">
    <div class="list form-list" style="height:100%">
      <el-form label-position="left" label-width="60px">
        <el-form-item label="조회대상" v-show="options.logOpts.enabled">
          <div class="log__wrapper">
            <el-scrollbar class="dashboard-log-tree__wrapper">
              <w-log-type-tree ref="logTypeTree" treeType="uncheck" :selectedNode.sync="selectedNode" @selectTreeNode="selectTreeNode" style="height:100%"/>
            </el-scrollbar>
          </div>
        </el-form-item>
        <el-form-item label="필드" v-show="options.logOpts.enabled">
          <div class="log__wrapper">
            <el-table
            :data="fieldTableData"
              ref="fieldListTable"
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="checked" header-align="left" align="center" label="선택" width="50">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.check_flag" @change="onFieldsCheckChange(...arguments, scope.row)"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                prop="fieldName"
                label="필드명"
                header-align="center"
                align="left"
              >
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import WLogTypeTree from '@/views/dashboard/widgets/grid/setting/components/LogTypeTree';
import IntegratedLogApi from '@/api/log/integrated-log';

import DashboardConst from '@/constants/dashboard';
import remove from 'lodash/remove';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WLogSelectPopup',
  components: {
    WLogTypeTree,
  },
  data() {
    return {
      options: {
        logOpts: {
          enabled: false,
          treeDataType: null,
        },
        logFieldOpts: {
          enabled: true,
        },
        logEventOpts: {
          enabled: false,
        },
      },
      selectedInfo: {

      },
      selectedNode: {},
      fieldTableData: [],
    };
  },
  computed: {
  },
  watch: {
    selectedNode(value) {
      if (this.selectedInfo.type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_INDEX) {
        this.setFields(this.selectedInfo.type);
      }
      if (value.length > 0) {
        this.selectedInfo.treeKeys = value;
      }
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.LOG_SELECT, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.LOG_SELECT, this.open);
  },
  methods: {
    open(datas) {
      Object.assign(this.options, datas.options);
      this.initData(datas.selectedInfo);
      this.$nextTick(() => {
        this.$refs.slidingPopup.open();
        this.loadData();
      });
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    closed() {
    },
    initData(selectedInfo) {
      this.selectedInfo = selectedInfo;
      this.selectedNode = {};
    },
    loadData() {
      const type = this.selectedInfo.type;

      if (type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_INDEX) {
        IntegratedLogApi.getLogIndexTree().then((response) => {
          if (!isEmpty(response.data) && response.data.success) {
            this.indexTreeData = response.data.data.children;
            this.$nextTick(() => {
              this.$refs.logTypeTree.setData([response.data.data]);
              this.setFields(this.selectedInfo.type);
              this.$nextTick(() => {
                this.$refs.logTypeTree.setDefaultNodeByTreeKey(this.selectedInfo.treeKeys);
              });
            });
          }
        });
      } else if (type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_FILTER) {
        IntegratedLogApi.getLogFilterTree().then((response) => {
          if (!isEmpty(response.data) && response.data.success) {
            this.filterTreeData = response.data.data.children;
            this.$nextTick(() => {
              this.$refs.logTypeTree.setData(response.data.data.children);
              this.setFields(this.selectedInfo.type);
              this.$nextTick(() => {
                this.$refs.logTypeTree.setDefaultNodeByTreeKey(this.selectedInfo.treeKeys);
              });
            });
          }
        });
      }
    },
    setFields(value) {
      let params = {};
      this.fieldTableData = [];
      if (value === DashboardConst.OPTIONS.SELECT_TYPE.LOG_INDEX) {
        const selectedIndex = this.selectedNode;
        // const selectedIndex = this.$refs.logIndexTree.getCurrentNode();
        params = {
          type: value,
          dataindexId: isEmpty(selectedIndex) ? this.indexTreeData[0].dataindexId : selectedIndex[0],
        };
        IntegratedLogApi.getKeywordMapSearchFields(params).then((response) => {
          this.fieldTableData = response.data.data;
          this.$nextTick(() => {
            this.fieldsCheckFlag();
          });
        });
      } else if (value === DashboardConst.OPTIONS.SELECT_TYPE.LOG_FILTER) {
        params = {
          type: value,
        };
        IntegratedLogApi.getKeywordMapSearchFields(params).then((response) => {
          this.fieldTableData = response.data.data;
          this.$nextTick(() => {
            this.fieldsCheckFlag();
          });
        });
      }
    },
    fieldsCheckFlag() {
      if (!isEmpty(this.selectedInfo.fields) && this.fieldTableData) {
        this.fieldTableData.forEach((field) => {
          field.check_flag = ((this.selectedInfo.fields.findIndex((item) => item.fieldId === field.fieldId)) !== -1);
        });
      }
    },
    onFieldsCheckChange(changeVal, evt, item) {
      if (changeVal) {
        this.selectedInfo.fields.push({
          fieldId: item.fieldId,
        });
        this.selectedInfo.fieldsName.push({
          fieldsName: item.fieldName,
        });
      } else {
        remove(this.selectedInfo.fields, (type) => type.fieldId === item.fieldId);
        remove(this.selectedInfo.fieldsName, (type) => type.fieldsName === item.fieldName);
      }
    },
    selectTreeNode(value) {
      const params = value;
      if (value.type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_FILTER) {
        IntegratedLogApi.getKeywordMapSearchFields(params).then((response) => {
          this.fieldTableData = response.data.data;
          this.$nextTick(() => {
            this.fieldsCheckFlag();
          });
        });
      }
    },
    onSaveClick() {
      const selectedLogObj = this.$refs.logTypeTree.getCurrentNode().nodes[0];

      if (this.options.logOpts.enabled) {
        const logSelectedLabel = isEmpty(selectedLogObj) ? '' : selectedLogObj.label;
        this.selectedInfo.selectedLabel = logSelectedLabel;

        const selectedFieldLabel = this.selectedInfo.fieldsName;
        let fieldLabel = isEmpty(selectedFieldLabel) ? '' : `${selectedFieldLabel[0].fieldsName}`;

        if (!isEmpty(selectedFieldLabel) && selectedFieldLabel.length > 1) {
          fieldLabel += ` 외 ${selectedFieldLabel.length - 1}개`;
        }

        this.selectedInfo.selectedFieldLabel = fieldLabel;
      }
      if (!isEmpty(selectedLogObj)) {
        if (this.selectedInfo.type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_INDEX) {
          this.selectedInfo.dataindexId = selectedLogObj.dataindexId;
        } else if (this.selectedInfo.type === DashboardConst.OPTIONS.SELECT_TYPE.LOG_FILTER) {
          this.selectedInfo.customFilterId = selectedLogObj.customFilterId;
        }
      }

      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.CHANGE_SELECTED_INFO, this.selectedInfo);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.log-select-popup {
  overflow-x: hidden;
  .content-wrapper {
    overflow-x: hidden;
    height: 100%;
    padding: 10px 10px 20px 10px;
    .log__wrapper {
      height: 100%;
      overflow-y: auto;
      border: 1px solid #e7e7e7;
      &.table {
        padding: 5px 5px 5px 5px;
        height: 145px;
        .el-scrollbar__view {
          height: 100%;
        }
      }
      .dashboard-log-tree__wrapper {
        .el-scrollbar__view {
          height: 100%;
        }
      }
    }
  }
  .list {
    &.form-list{
      .el-form--label-left {
        height: 100%;
        .el-form-item {
          height: 50%;
        }
      }
    }
  }
  .el-form-item__content {
    height: calc(100% - 16px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/LogSelectPopup.vue